import React from "react";
import {
  ChatOutlined,
  PersonOutlined,
  AssistantOutlined,
  TimelineOutlined,
  DashboardOutlined,
  GroupWorkOutlined,
  PermIdentity,
  Call,
  StorefrontOutlined,
  FeaturedPlayListOutlined,
  AssignmentInd,
  Event as EventIcon,
} from "@material-ui/icons";

import AgentProfilePage from "../../../pages/AgentProfile/AgentProfilePage";
import DashboardPage from "../../../pages/Dashboard/DashboardPage";
import TemplateLibraryPage from "../../../pages/TemplateLibrary/TemplateLibraryPage";
import TemplateMsgPage from "../../../pages/TemplateMsg/TemplateMsgPage";
import AssistantsPage from "../../../pages/Assistants/AssistantsPage";
import OrdersPage from "../../../pages/Orders/OrdersPage";
import ClientsPage from "../../../pages/Clients/ClientsPage";
import PartnersPage from "../../../pages/Partners/PartnersPage";
import CRMPage from "../../../pages/CRM/CRMPage";
import VirtualNumberPage from "../../../pages/VirtualNumber/VirtualNumberPage";
import Report from "../../../pages/Reporting/Report";
import AssessmentIcon from "@material-ui/icons/Assessment";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import AffiliatePage from "../../../pages/Affiliates/AffiliatePage";
import SettingsIcon from "@material-ui/icons/Settings";
import ManageAgents from "../../Manage/ManageAgents";
import KycSignalPage from "../../../pages/KycSignal/KycSignalPage";
import AccessCodeDashboard from "../../../pages/AccessCode/AccessCodeDashboard";
import FireplaceIcon from "@material-ui/icons/Fireplace";
import Dashboard from "../../../pages/PaymentPages/Dashboard";
import PaymentsDashboard from "../../../pages/PaymentAnalytics/PaymentsDashboard";
import CheckoutAnalyticsPage from "../../../pages/CheckoutAnalytics/CheckoutAnalyticsPage";
import AgentFleetPage from "../../../pages/AgentAnalytics/AgentFleetPage";
import AdTemplateAnalyticsPage from "../../../pages/AdTemplateAnalytics/AdTemplateAnalyticsPage";
import FlowLibraryPage from "../../../pages/FlowLibrary/FlowLibraryPage";
import MarketplacePage from "../../../pages/Marketplace/MarketplacePage";
import CheckoutProductsPage from "../../../pages/CheckoutProducts/CheckoutProductsPage";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import StorefrontIcon from "@material-ui/icons/Store";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import ShopifyRewardsPage from "../../../pages/ShopifyRewards/ShopifyRewardsPage";
import MetaAdsJourneyPage from "../../../pages/MetaAdsJourney/MetaAdsJourneyPage";
import GoogleAdsPilotConsolePage from "../../../pages/GoogleAdsPilotConsole/GoogleAdsPilotConsolePage";
import SpamReviewPage from "../../../pages/SpamReview/SpamReviewPage";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import { TENANT_ID } from "../../../config/config";
const tenantRoutes = [
  {
    name: "Employee",
    to: "/employee",
    component: ManageAgents,
    icon: <SettingsIcon style={{ fontSize: "20px" }} />,
    power: 20,
    manage: 0,
  },
  {
    name: "Assistants",
    to: "/assistants",
    component: AssistantsPage,
    icon: <FeaturedPlayListOutlined style={{ fontSize: "20px" }} />,
    power: 12,
    manage: 0,
  },
  {
    name: "Partners",
    to: "/",
    component: PartnersPage,
    icon: <GroupWorkOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Marketplace",
    to: "/marketplace",
    component: MarketplacePage,
    icon: <StorefrontIcon style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
];

const topRoutes = [
  {
    name: "Reporting",
    to: "/reporting",
    component: Report,
    icon: <AssessmentIcon style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Rewards",
    to: "/rewards",
    component: ShopifyRewardsPage,
    icon: <CardGiftcardIcon style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "CRM",
    to: "/crm",
    component: CRMPage,
    icon: <PermIdentity style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Templates",
    to: "/template-messages",
    component: TemplateMsgPage,
    icon: <ChatOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Assistants",
    to: "/assistants",
    component: AssistantsPage,
    icon: <FeaturedPlayListOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },

  {
    name: "Kyc Signal",
    to: "/kyc",
    component: KycSignalPage,
    icon: <AssignmentInd style={{ fontSize: "20px" }} />,
    power: 11,
    manage: 0,
  },
  {
    name: "Affiliates",
    to: "/affiliates",
    component: AffiliatePage,
    icon: <GroupAddIcon style={{ fontSize: "20px" }} />,
    power: 11,
    manage: 0,
  },
  {
    name: "Offer Codes",
    to: "/diwali-offer-codes",
    component: AccessCodeDashboard,
    icon: <FireplaceIcon style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Evolve",
    to: "/dubai-evolve",
    component: Dashboard,
    icon: <EventIcon style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Clients",
    to: "/clients",
    component: ClientsPage,
    icon: <StorefrontOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Orders",
    to: "/orders",
    component: OrdersPage,
    icon: <TimelineOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Payment History",
    to: "/payment-analytics",
    component: PaymentsDashboard,
    icon: <ReceiptOutlinedIcon style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Checkout Analytics",
    // The path must equal "/" + the ACL key: accessControlHelper matches a
    // stored permission's label (which is the tree's `key`) against route.to.
    // Keep this, CreateRole's key, and whatsapp-rest-api's tree in lockstep.
    to: "/checkout-analytics",
    component: CheckoutAnalyticsPage,
    icon: <AssessmentIcon style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Checkout Products",
    to: "/checkout-products",
    component: CheckoutProductsPage,
    icon: <ShoppingCartOutlinedIcon style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Agent Analytics",
    to: "/agent-analytics",
    component: AgentFleetPage,
    icon: <AssessmentIcon style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Ad Template Analytics",
    to: "/ad-template-analytics",
    component: AdTemplateAnalyticsPage,
    icon: <AssessmentIcon style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Meta Ads Journey",
    to: "/meta-ads-journey",
    component: MetaAdsJourneyPage,
    icon: <TimelineOutlined style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Google Ads Pilot Console",
    to: "/google-ads-pilot-console",
    component: GoogleAdsPilotConsolePage,
    icon: <TimelineOutlined style={{ fontSize: "20px" }} />,
    power: 9,
    manage: 0,
  },
  {
    name: "Spam Review",
    to: "/spam-review",
    component: SpamReviewPage,
    icon: <ReportProblemOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Library",
    to: "/library",
    component: TemplateLibraryPage,
    icon: <AssistantOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Flow Library",
    to: "/flow-library",
    component: FlowLibraryPage,
    icon: <AssistantOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Marketplace",
    to: "/marketplace",
    component: MarketplacePage,
    icon: <StorefrontIcon style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Partners",
    to: "/partners",
    component: PartnersPage,
    icon: <GroupWorkOutlined style={{ fontSize: "20px" }} />,
    power: 10,
    manage: 0,
  },
  {
    name: "Virtual Numbers",
    to: "/virtual-numbers",
    component: VirtualNumberPage,
    icon: <Call style={{ fontSize: "20px" }} />,
    power: 11,
    manage: 1,
  },
  {
    name: "Employee",
    to: "/employee",
    component: ManageAgents,
    icon: <SettingsIcon style={{ fontSize: "20px" }} />,
    power: 20,
    manage: 0,
  },
  {
    name: "Dashboard",
    to: "/",
    component: DashboardPage,
    icon: <DashboardOutlined style={{ fontSize: "20px" }} />,
    power: 0,
    manage: 1,
  },

  // {
  //   name: "Dialogflow",
  //   to: "/dialogflow",
  //   component: DfIntegrationPage,
  //   icon: <AssistantOutlined style={{ fontSize: "20px" }} />,
  //   power: 2,
  //   manage: 1,
  // },
  // {
  //   name: "Template Message",
  //   to: "/template-message",
  //   component: TemplateMsgPage,
  //   icon: <Message style={{ fontSize: "20px" }} />,
  //   power: 2,
  //   manage: 1,
  // },
  // {
  //   name: "Tags",
  //   to: "/tags",
  //   component: TagsPage,
  //   icon: <LoyaltyOutlined style={{fontSize: "20px"}}/>,
  //   power: 0,
  //   manage: 1
  // },
  // {
  //   name: "Campaigns",
  //   to: "/campaigns",
  //   component: CampaignsPage,
  //   icon: <FlightTakeoffOutlined style={{ fontSize: "20px" }} />,
  //   power: 2,
  //   manage: 0,
  // },
  // {
  //   name: "Canned",
  //   to: "/canned-messages",
  //   component: CannedMessagesPage,
  //   icon: <LoyaltyOutlined style={{fontSize: "20px"}}/>,
  //   power: 2,
  //   manage: 0
  // },
  // {
  //   name: "Billings",
  //   to: "/billings",
  //   component: BillingsPage,
  //   icon: <AccountBalanceWallet style={{ fontSize: "20px" }} />,
  //   power: 2,
  //   manage: 1,
  // },
];

const bottomRoutes = [
  {
    name: "Profile",
    to: "/agentProfile",
    component: AgentProfilePage,
    icon: <PersonOutlined />,
  },
];

// Routes shown in the sidebar for the current user — shared by the desktop
// nav bar and the Cmd/Ctrl+P tab switcher so both list exactly the same tabs.
const getNavRoutes = (permissions) => {
  if (TENANT_ID) return tenantRoutes;
  return topRoutes.filter((route) => {
    if (route.to === "/") {
      const permission = permissions?.find((p) => p.label === "dashboard");
      return permission?.read;
    }
    if (route.to === "/marketplace") {
      const permission = permissions?.find((p) => p.label === "marketplace");
      return permission?.read;
    }
    const permission = permissions?.find((p) => "/" + p.label === route.to);
    return permission?.read;
  });
};

export { topRoutes, bottomRoutes, tenantRoutes, getNavRoutes };
